import React from "react";

export default function UserIcon() {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 15.7574C1 13.4638 3.6288 10.8606 9 10.8606C14.3712 10.8606 17 13.4638 17 15.7574C17 17.0638 15.8 17.4638 14.584 17.4638H3.41602C2.20002 17.4638 1 17.0638 1 15.7574Z" stroke="#878787" strokeWidth="1.2"/>
    <path d="M12 4.46362C12 6.12042 10.6568 7.46362 9 7.46362C7.3432 7.46362 6 6.12042 6 4.46362C6 2.80682 7.3432 1.46362 9 1.46362C10.6568 1.46362 12 2.80682 12 4.46362Z" stroke="#878787" strokeWidth="1.2"/>
    </svg>   
    
  );
}
